import React from 'react';

const JS_Plotly = () => {
  return (
    <div >
      <h1>JS_Plotly</h1>
      <p>Placeholder component for: "JS Plotly"</p>
    </div>
  );
};

export default JS_Plotly;
